import { supabase } from "../lib/api";

export const initializeUser = async (username: string) => {
  if (username.length > 2) {
    return await supabase.auth.updateUser({
      data: {
        username: username,
        points: 20,
        total_points: 20,
        likedLinks: [],
      },
    });
  }
};
